import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { LoadingController } from '@ionic/angular';
import { UsdaService, Food } from '../../../services/usda.service';

@Component({
  selector: 'food-find',
  templateUrl: './food-find.component.html',
  styleUrls: ['./food-find.component.scss']
})
export class FoodFindComponent implements OnInit {


  searchTerm: string;

  @Input() placeholder: string;
  @Output() onFoodSelected = new EventEmitter();

  searchFoods: any;
  foodDetails: Food;
  offset: number = 0;

  constructor(public api: UsdaService, public loadingController: LoadingController) { }

  filterSearchItems() {
    console.log('Food search component: in filter search items: ' + this.searchTerm);

    this.searchFoods = new Array();
    if (this.searchTerm && this.searchTerm.length > 0) {
      this.remoteSearch(this.searchTerm);
    }
  }


  remoteSearch(searchTerm: string) {

    this.api.searchRemoteFood(searchTerm, this.offset)
      .subscribe(res => {

        if (res) {
          res.list.item.forEach(element => {
            let foodgrp = this.api.foodGroupsByKey.get(element.group);
            if (foodgrp) {
              element.foodgroup = foodgrp;
            }
            else {
              element.foodgroup = '0100';
            }

            this.searchFoods.push(element);
          });

        } else {
          console.log('*******no results for: ' + searchTerm);
        }
      }, err => {
        console.log('**ERROR' + err);
      });

  }

  setSearchFocus() {
    console.log('Food search component: in set focus');
  }

  async onSelectFood(ndb_no: string, fdGrp: string) {
    console.log('selected: ' + ndb_no + ' food group: ' + fdGrp);

    const loading = await this.loadingController.create({});

    await loading.present();

    await this.api.getRemoteFoodDetails(ndb_no)
      .subscribe(res => {
        this.foodDetails = res.foods[0];
        this.foodDetails.group = fdGrp;
        this.onFoodSelected.emit(this.foodDetails);
        loading.dismiss();
      }, err => {
        console.log('**ERROR' + err);
        loading.dismiss();
      });

    this.searchFoods = undefined;
    this.searchTerm = undefined;
  }

  // https://beta.ionicframework.com/docs/api/infinite-scroll
  doInfinite(infiniteScroll) {
    console.log('infinite scrolling...');

    if (this.searchTerm) {
      setTimeout(() => {
        this.offset += 25;
        console.log('offset: ' + this.offset);
        this.api.searchRemoteFood(this.searchTerm, this.offset)
          .subscribe(res => {
            res.list.item.forEach(element => {
              let foodgrp = this.api.foodGroupsByKey.get(element.group);
              if (foodgrp) {
                element.foodgroup = foodgrp;
              }
              else {
                element.foodgroup = '0100';
              }

              this.searchFoods.push(element);
            });
          }, err => {
            console.log('**ERROR' + err);
          });
        console.log('Async operation has ended');
        infiniteScroll.target.complete();
      }, 500);
    }
  }
  
  ngOnInit() {
  }
}
